/* eslint-disable max-classes-per-file */
export interface Root {
  status: boolean;
  message: any;
  data: EventAllocateInterface;
}

export interface EventFootballAllocate {
  contactTitle: string;
  contactFirstname: string;
  contactLastname: string;
  contactEmail: string;
  contactPhone: string;
  contactPrefixPhone?: string;
  tickets?: {
    type: string;
    amount: number;
    bookingInfo: {
      titlename: string;
      firstname: string;
      lastname: string;
      countryOfPassport: string;
      passportNumber: string;
      dob: string;
    }[];
  }[];
  [key: string]: number | string | undefined | any;
}

export interface EventAllocateInterface {
  bookingInternalNo: string;
  rsvnId: number;
  currency: string;
  tickets: Ticket[];
  totalAmount: number;
  totalPrice: number;
  paymentUrl: string;
}

export interface Ticket {
  name: string;
  ticketType: string;
  price: number;
  amount: number;
  pricePerAmount: number;
}

export class EventAllocateResponse {
  bookingInternalNo: string;

  rsvnId: number;

  currency: string;

  tickets: {
    name: string;
    ticketType: string;
    price: number;
    amount: number;
    pricePerAmount: number;
  }[];

  totalAmount: number;

  totalPrice: number;

  paymentUrl: string;

  constructor(data: any) {
    this.bookingInternalNo = data?.bookingInternalNo || 0;
    this.rsvnId = data?.rsvnId || 0;
    this.currency = data?.currency || "";
    this.tickets = data?.tickets || [
      {
        name: "",
        ticketType: "",
        price: 0,
        amount: 0,
        pricePerAmount: 0,
      },
    ];
    this.totalAmount = data?.totalAmount || 0;
    this.totalPrice = data?.totalPrice || 0;
    this.paymentUrl = data?.paymentUrl || "";
  }
}

export class EventAllocateData {
  status: boolean;

  message: string;

  data: EventAllocateInterface;

  constructor(response: EventAllocateData) {
    this.status = response?.status || false;
    this.message = response?.message || "";
    this.data = new EventAllocateResponse(response.data);
  }
}
